import { getObjectValue } from '@services/object-extensions';
import cn from 'classnames';

const LayoutTestoTitolo = ({ translations = {}, darkTheme = false }) => {
  return (
    <div
      className="snf-lx-components-servizi-soluzioni-layout-testo-titolo-layout-testo-titolo"
      style={{ display: 'contents' }}
    >
      <>
        <div
          className={cn(`row `, {
            'snf-text-color-white': darkTheme
          })}
        >
          <div className="col-11 snf-font-32 snf-font-w6 mb-2 title p-0">
            {getObjectValue(translations, 'title', '')}
          </div>
        </div>
        <div
          className={cn(`row `, {
            'snf-text-color-white': darkTheme
          })}
        >
          <div className="col-11 snf-font-20 snf-font-w6 mb-4 subtitle p-0">
            {getObjectValue(translations, 'subtitle', '')}
          </div>
        </div>
      </>
    </div>
  );
};

LayoutTestoTitolo.displayName = 'Layout Testo Titolo';
export { LayoutTestoTitolo };
